import { render, staticRenderFns } from "./bill-table.vue?vue&type=template&id=383e1b24&scoped=true&"
import script from "./bill-table.vue?vue&type=script&lang=js&"
export * from "./bill-table.vue?vue&type=script&lang=js&"
import style0 from "./bill-table.vue?vue&type=style&index=0&id=383e1b24&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383e1b24",
  null
  
)

export default component.exports